export const BaseEventTypes = {
  CREATED_MANY: 'CREATED_MANY',
  CREATED: 'CREATED',
  DELETED: 'DELETED',
  UPDATED: 'UPDATED',
  UPSERTED: 'UPSERTED',
} as const
